module.exports = __webpack_public_path__ + "static/media/ban-2x.af0bfee6.png";